import { format } from "date-fns";
import { ru } from "date-fns/locale";

/**
 * Выводим Date в виде "19 апреля"
 */
export const formatDateToDDMMMM = (d: string) => format(d, "d MMMM", { locale: ru });

export const getDayOfWeekString = (d: Date) => format(d, "EEEE", { locale: ru });
